/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-12 15:40:50                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 16:02:48                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Services
  * DetailsDrawer: display details drawer
*/

/* Imports */
import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { Modal } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";
/***/

/* Components */
/***/

/* Services */
import { api } from "../../../../../services/api/api";
/***/

import "./PlanningModal.scss";
import Loading from "../../../../../components/loading/Loading";

/**
* DetailsDrawer: display details drawer
* @param time - time to display
* @param onUpdate - on update callback, return updated time
*/
export default function DeleteWorkorderModal({
  open,
  workorder,
  onDelete,
  onClose
}: {
  open: boolean,
  workorder: EasyTech.Workorder,
  onDelete: () => void
  onClose: () => void
}) {
  const [delLoad, setDelLoad] = useState<boolean>(false); 
  
  const deleteWo = () => {
    setDelLoad(true);
    api.delete(`admin/workorders/disable/${workorder.id}`, {})
      .then((ret) => {
        toast.success(t("workorder:delete:success"));
        onDelete();
      }).catch((err) => {
        toast.error(t("workorder:delete:error"));
      }).finally(() => {
        onClose();
      });
  };
  
  return(
    
    <Modal
      open={open}
      onClose={onClose}
      className="te-modal"
      aria-labelledby="te-modal"
      aria-describedby="te-modal">
      <Card className="te-modal-content  rounded-lg">
        <button className="close-button" onClick={() => onClose()}>
          <XMarkIcon className="w-4"/>
        </button>
        <CardBody>
          <div  className="flex items-center gap-3 mb-5">
            <div className="rounded-full border p-2 bg-red-200 bg-">
              <TrashIcon className="w-7 text-red-700" /> 
            </div>
            <Typography variant="h5">
              {t("admin:interventions:delete:title", { ref: workorder.ref })}
            </Typography>
          </div>

          <Typography variant="paragraph">
            {t("admin:interventions:delete:description")}
          </Typography>
        </CardBody>
        <CardFooter className="pt-0 flex gap-2 justify-end">
          <Button variant="outlined"
                  onClick={onClose}>
            {t("common:cancel")}
          </Button>

          {delLoad ?
            <Loading />
            :
            <>
              <Button color="blue"
                      onClick={() => deleteWo()}>
                {t("common:delete")}
              </Button>
            </>
          }
        </CardFooter>
      </Card>
    </Modal>
  );
}
/***/
